import * as links from '../../../constants/links';
import {
  replaceLocation,
} from '../../../router';

export default [
  [`^/?$`, () => {
    replaceLocation({
      path: links.LINK_SIGN_IN,
    });
  }],


  [`^${links.LINK_ACCESS_DENIED}/?$`, {
    title: 'Access Denied',
    main: require('../../../components/pages/PublicError/AccessDenied'),
    public: 1,
  }],

  [`^/?confirm_email(/([^/]+):token)$`, {
    title: 'Email confirmation',
    main: require('../../../components/pages/Auth/ConfirmationEmail'),
    public: 1,
  }],
  [`^${links.LINK_BLOCKED}(/([^/]+):email/?)?$`, {
    title: 'Account is blocked',
    main: require('../../../components/pages/Auth/Blocked'),
    public: 1,
  }],
  [`^${links.LINK_FORGOT_PASSWORD}/?$`, {
    title: 'Forgot password',
    main: require('../../../components/pages/Auth/ForgotPassword').default,
    public: 1,
  }],
  [`^${links.LINK_RECOVERY_TOKEN}(/([^/]+):token)?$`, {
    title: 'Recovery token',
    main: require('../../../components/pages/Auth/RecoveryToken').default,
    public: 1,
  }],
  [`^${links.LINK_START}/?$`, {
    title: 'Sign up',
    main: require('../../../components/pages/Auth/Start').default,
    public: 1,
  }],
  [`^${links.LINK_SIGN_IN}/?$`, {
    title: 'Sign in',
    main: require('../../../components/pages/Auth/SignIn').default,
    public: 1,
  }],
  [`^${links.LINK_SECURITY_VERIFICATION}/?$`, {
    title: 'Security verification',
    main: require('../../../components/pages/Auth/Security').default,
    public: 1,
    kyc: 1,
  }],
  [`^${links.LINK_START_VERIFICATION}/(([^/]+):email/?)?$`, {
    title: 'Confirm your account creation',
    main: require('../../../components/pages/Auth/VerificationCode').default,
    public: 1,
    // kyc: 1,
  }],
  [`^${links.LINK_RESET_SECURITY_VERIFICATION}/?$`, {
    title: 'Reset security verification',
    main: require('../../../components/pages/Auth/Reset'),
    public: 1,
  }],
  [`^${links.LINK_START_STEP}/(([^/]+):step)?$`, {
    main: require('../../../components/pages/Onboarding/Steps'),
    public: 1,
    kyc: 1,
  }],
];
